import React from 'react';
import { connect } from 'react-redux';
import { callService } from '../tools';

const mapState = (state) => {
	return {
		familiar : state.af.familiar,
		listaPolizas: state.af.listaPolizas,
		listaGuardar: state.af.listaGuardar,
		listaVigencia: state.af.listaVigencia
	};
}

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		goTo: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO", "paso": paso });
		}
	}
}

class GestionarAcceso extends React.Component {

	reenviar = () => {
		let $this = this;
		$this.props.loader(true);

		let llamaServicio = new callService({
			service: 'accesoFamiliar.reenviaInvitacion',
			secure: true,
			data: {
				familiar: this.props.familiar.id
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.loader(false);
			$this.props.goTo(3);
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);
			$this.props.alerta(error.message.mensaje);
		});
	}

	eliminar = () => {
		this.props.goTo(2);
	}

	gestionar = () => {
		this.props.goTo(1);
	}

	/*guardar = () => {
		let $this = this;
		$this.props.loader(true);

		let llamaServicio = new callService({
			service: 'accesoFamiliar.editarFamiliar',
			token: this.props.tid,
			data: {
				familiar: this.props.familiar.id,
				polizas: this.props.listaGuardar,
				vigencias: this.props.listaVigencia
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.loader(false);
			$this.volver();
		}).catch((error) => {
			console.log("error", error);
			$this.props.loader(false);
			$this.volver();

			$this.props.alerta(error.message.mensaje);
		});
	}*/

	volver = () => {
		$("#modal-gestionar").modal("toggle");
	}

	render() {
		return <div>
			<h5><i><img src={ require("../img/documentos-icono.png") } /></i>Acceso a pólizas
				<button type="button" className="close pull-right" data-dismiss="modal" aria-label="Close" style={{"width": "initial", "marginRight":"10px"}}><img src={ require("../img/x.svg") } alt="" /></button>
			</h5>
			<div className="row acceso-container">
				<div className="col-xs-12 mb-20">
					<div className="row">
						<div className="col-md-2 col-xs-2">
							<img src={ require("../img/circle_contratante.png") } />
						</div>
						<div className="col-xs-8 col-md-8">
							<p><b className="blue-text">{this.props.familiar.nombre}</b></p>
							{ this.props.familiar.pendiente == true &&
								<p><span className="blue-circle"></span><small className="gray-text">Invitación aceptada</small></p>
							}
							{ this.props.familiar.pendiente == false && this.props.familiar.polizas.length != 0 &&
								<p><span className="red-circle-no"></span><small className="gray-text">Pendiente de aceptar</small></p>
							}
                            { this.props.familiar.pendiente == false && this.props.familiar.polizas.length == 0 &&
                                <p><span className="red-circle-no"></span><small className="gray-text">Sin pólizas compartidas</small></p>
                            }
						</div>
						<div className="col-xs-2 no-pad-left text-center">
							<span className="texto-20 orange-text">{ this.props.familiar.polizas.length }</span><br />
							<small className="gray-text">Pólizas</small>
						</div>
					</div>
				</div>
			</div>
			<div className="row acceso-container">
				<div className="col-xs-12 mb-20">

					<div className="overflow-wrap mt-25">
						<ul>
							{ this.props.listaPolizas.map((item, i) => {
								if(this.props.familiar.polizas.indexOf(item.generales.numPoliza) != -1) {
									return <li key={i} className="clearfix">
										<div className="col-xs-6" style={{"padding":"0 5px"}}>
											<h6>{item.vehiculo.descripcion}</h6>
											<p>
												<i><img src={ require("../img/icon-poliza.png") } /></i>
												Póliza N: {item.generales.numPoliza}
											</p>
										</div>
										<div className="col-xs-4 text-right" style={{"padding":"0 5px"}}>
											<h6><b>{item.vehiculo.placas}</b></h6>
											<p><span className="blue-text">MODELO {item.vehiculo.modelo}</span></p>
										</div>
										<div className="col-xs-2" style={{"padding":"0 5px", "textAlign":"center"}}>
											<div className="checkbox-blue text-right">
												<input type="checkbox" checked disabled />
												<label></label>
											</div>
										</div>
									</li>
								}
							})}
						</ul>
					</div>
					<div className="polizas-opciones row">
						<div className="col-xs-12">
							<div className="text-center eliminar-gestionar-btn">
								<a onClick={this.gestionar.bind(this)}><span><b>Gestionar pólizas</b></span></a>
								<a onClick={this.eliminar.bind(this)}><span><b>Eliminar invitado</b></span></a>
							</div>
						</div>
					</div>
					{/* this.props.familiar.polizas.length > 0 && this.props.familiar.pendiente == false &&
						<div className="col-xs-10 col-xs-offset-1 col-sm-4 col-sm-offset-0">
							<a onClick={this.reenviar.bind(this)}>
								<i><img src={ require("../img/letter.png") } /></i>
								<span>Reenviar invitación</span>
							</a>
						</div>
					*/}
					{/*<div className="text-center aceptar-cancelar-btn mt-10">
						<a onClick={this.volver.bind(this)}>Volver</a>
						<a onClick={this.guardar.bind(this)} className="orange-btn">Guardar</a>
					</div>*/}
				</div>
			</div>
		</div>
	}
}

export default connect(mapState, mapDispatch)(GestionarAcceso);



// WEBPACK FOOTER //
// ./src/acceso-familiar/GestionarAcceso.cmpt.js